import { Injectable } from '@angular/core';
import { Servicejob } from 'src/app/_model/servicejob';
import { TagTemplateElement } from 'src/app/_model/tag-template-element';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import {
  DbPersistenceService, Query
} from 'src/app/_services/persistence/db-persistence/db-persistence.service';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { TagStatesService } from 'src/app/_services/tag-states/logic/tag-states.service';
import { TagTemplatesElementsDaoService } from '../tag-templates-elements-dao.service';
import { TagTemplatesElementDbTableDefinition } from './tag-templates-element-db-table-definition';

@Injectable()
export class TagTemplatesElementsDbDaoService implements TagTemplatesElementsDaoService {

  constructor(
    private logger: LoggingService,
    private dbPersistenceService: DbPersistenceService,
    private tagStatesService: TagStatesService,
    private keyValuePersistenceService: KeyValuePersistenceService,
    private tagTemplatesElementTableDefinition: TagTemplatesElementDbTableDefinition,
  ) { }

  async saveTagTemplatesElements(tagTemplatesElements: TagTemplateElement[]): Promise<void> {
    try {
      const db = await this.dbPersistenceService.getImsDb();

      const queries: Query[] = [];
      for (const tagTemplateElement of tagTemplatesElements) {
        queries.push({
          statement:
            `INSERT OR REPLACE INTO ${this.tagTemplatesElementTableDefinition.tableName} (id, label, databag, parentid, parentlabel, tagtemplateid, tagtemplatelabel) VALUES (?,?,?,?,?,?,?)`,
          parameters: [
            Number(tagTemplateElement.isLocal() ? tagTemplateElement.id.secondaryId : tagTemplateElement.id.imsId),
            tagTemplateElement.label,
            tagTemplateElement.databag ? JSON.stringify(tagTemplateElement.databag) : undefined,
            tagTemplateElement.parent?.getImsId(),
            tagTemplateElement.parent?.label,
            tagTemplateElement.tagtemplate?.getImsId(),
            tagTemplateElement.tagtemplate?.label
          ]
        });
      };
      await this.dbPersistenceService.executeBatch(db, queries);

    } catch (error) {
      this.logger.log('Error saving tagtemplateselements to db', error, '-', error.message);
    }
  }

  async getTagTemplatesElements(): Promise<TagTemplateElement[]> {
    const db = await this.dbPersistenceService.getImsDb();
    const tagTemplateElements: TagTemplateElement[] = [];

    try {
      const data = await this.dbPersistenceService.executeQuery(db, {
        statement: 'SELECT * FROM ' + this.tagTemplatesElementTableDefinition.tableName + ';',
        parameters: null
      });
      for (let i = 0; i < data.values.length; i++) {
        const row = data.values[i];
        tagTemplateElements.push(
          TagTemplateElement.fromDto({
            id: row['id'],
            secondaryid: undefined,
            label: row['label'],
            parent: {
              id: row['parentid'],
              label: row['parentlabel']
            },
            tagtemplate: {
              id: row['tagtemplateid'],
              label: row['tagtemplatelabel']
            }
          }, row['databag'] ? JSON.parse(row['databag']) : undefined)
        );
      }
    } catch (error) {
      this.logger.log('Error reading TagTemplateElements from db', error);
    }

    return tagTemplateElements;
  }

  async reset(): Promise<void> { }

  async clear(): Promise<void> {
    const db = await this.dbPersistenceService.getImsDb();
    await this.dbPersistenceService.truncateTable(db, this.tagTemplatesElementTableDefinition.tableName);
  }

  async getTagStatesForPhotodocForCurrentServiceJob(currentJob: Servicejob, tagTemplateELements: TagTemplateElement[]): Promise<void> {
    if (currentJob?.tagtemplatevalid?.getImsId() == null) {
      return;
    }

    // filteredTags for set tag template
    const tags = tagTemplateELements.filter(tag => tag.tagtemplate?.getImsId() === currentJob.tagtemplatevalid?.getImsId());
    const tagStates = new Map(<any[]>(await this.keyValuePersistenceService.load(TagStatesService.PERSISTED_TAG_STATES))?.filter(tagState => tagState.ownerid === currentJob.getImsId()).map(tag => {
      return [tag.tagtemplateelementid, tag];
    }));

    tags.forEach(tag => {
      tag[TagStatesService.TAG_STATE] = tagStates.get(tag.getImsId());
    });

    this.tagStatesService.tagTemplatesWithStateForPhotodocForServiceJob$.next(tags);
  }
}
